import Swiper, { Navigation } from 'swiper';

const blockTikTok = () => {
  const tikTokSwiper = document.querySelector('.s-tik-tok__swiper');

  if (tikTokSwiper) {
    // eslint-disable-next-line no-unused-vars
    const swiper = new Swiper(tikTokSwiper, {
      direction: 'horizontal',
      loop: true,
      modules: [Navigation],
      slidesPerView:1,breakpoints:{992:{slidesPerView:3}},
      spaceBetween: 15,
      navigation: {
        nextEl: '.s-tik-tok__arrow--next',
        prevEl: '.s-tik-tok__arrow--prev',
      },
    });
  }
};

export default blockTikTok;
